import type { IModality } from '@/types';

export const maodalities: IModality[] = [
  {
    id: 2,
    name: 'TAÇA DE PORTUGAL',
    available_genders: null,
    gender: '',
  },
  {
    id: 1,
    name: 'A HISTÓRIA DA FPF',
    available_genders: null,
    gender: '',
  },
];
